module.exports = __webpack_public_path__ + "img/microorganisms_cover.b9bc5afa.jpg";